import React from 'react';
import { Box, Typography } from '@mui/material';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import { COLORS } from './tokens';

/**
 * Solid forest-green card telling the user to come back to the browser tab
 * (mobile D03). Installing the Visualizador takes the user out of the browser,
 * so returning is the most important instruction on the screen — hence its own
 * heavy visual treatment.
 */
export default function ReturnCallout({ title = 'Não esqueça de voltar pra cá', children }) {
    return (
        <Box
            sx={{
                display: 'flex',
                gap: 1.75,
                alignItems: 'flex-start',
                p: 2.25,
                backgroundColor: COLORS.forest,
                borderRadius: '14px',
                color: '#fff'
            }}
        >
            <Box
                sx={{
                    width: 34,
                    height: 34,
                    borderRadius: '50%',
                    flex: 'none',
                    backgroundColor: 'rgba(255,255,255,0.16)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <KeyboardReturnIcon sx={{ fontSize: 19 }} />
            </Box>

            <Box>
                <Typography sx={{ fontWeight: 700, fontSize: 16, lineHeight: 1.25 }}>{title}</Typography>
                <Typography sx={{ fontSize: 15, lineHeight: 1.45, mt: 0.375, opacity: 0.92 }}>
                    {children || 'Depois de instalar e abrir o Visualizador, volte para esta aba do navegador para mandar sua primeira notificação.'}
                </Typography>
            </Box>
        </Box>
    );
}
